import { render, staticRenderFns } from "./TableProductTop.vue?vue&type=template&id=65625cb5&scoped=true&lang=pug&"
import script from "./TableProductTop.vue?vue&type=script&lang=js&"
export * from "./TableProductTop.vue?vue&type=script&lang=js&"
import style0 from "./TableProductTop.vue?vue&type=style&index=0&id=65625cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65625cb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
